/**
 * The on-disk format specification, served from the portal.
 *
 * `FORMAT.md` is published under CC0 and the whole point of it is that anyone
 * can implement a restorer without our source — but it lives in a private
 * repository, so every link that pointed at GitHub 404'd for exactly the
 * audience the document exists for. Rendering it here keeps the repository
 * private while making the spec genuinely public, and keeps it versioned with
 * the site rather than needing a separate publish pipeline.
 *
 * The contents list and the article itself come from `../MarkdownPage`, shared
 * with the Help guides, so both kinds of page keep the same heading-anchor
 * behaviour. `markdown.test.ts` pins one of those slugs, since deep links
 * people already hold (`#82-snapshot-records`) need to keep resolving.
 */

import { MarkdownPage } from "../MarkdownPage";
import specSource from "../../../../FORMAT.md?raw";
import specUrl from "../../../../FORMAT.md?url";

export function Spec() {
  return (
    <>
      <section className="page-header">
        <h1>Format specification</h1>
        <p className="muted">
          The complete on-disk format, published under CC0 — implement it freely.
          A backup you cannot restore is not a backup, so this document is
          detailed enough to write a restore tool against without our source code.
        </p>
        <p>
          <a className="button button--small" href={specUrl} download="FORMAT.md">
            Download raw Markdown
          </a>
        </p>
      </section>

      {/* The one piece of decoration this page gets. A strip rather than a
          banner, and no copy on it: the spec is read, not sold, and the text
          below it stays undecorated. Decorative, so it is a CSS background
          with nothing to announce. */}
      <div className="spec-strip marketing__bleed" aria-hidden="true" />

      <MarkdownPage source={specSource} tocLabel="Specification contents" />
    </>
  );
}
